const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {assessments} assessments the resource defined to manage assessments
 */
app.directive('questionAnswerPresenter', ['AssessmentLib', function (AssessmentLib) {
  return {
    restrict: 'E',
    scope: {
      adminView: '@',
      question: '=',
      gradedResponses: '=',
      videoAssessment: '=',
      fileAssessment: '='
    },
    template: require('../../../templates/directives/assessments/question-answer-presenter.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.helpers = {
        stopProp: function(evt) {
          evt.stopPropagation();
        }
      };

      self.isPdf = function(item) {
        if (!item || !item.link) {
          return false;
        }
        return item.link.slice(-3) === 'pdf';
      };

      self.isImage = function(item) {
        if (!item || !item.link) {
          return false;
        }
        return item.link.slice(-3) === 'png' || item.link.slice(-4) === 'jpeg';
      };

      self.isOther = function(item) {
        return !self.isPdf(item) && !self.isImage(item);
      };

      self.info = {
        settings: {},
        videoSource: 'custom',
        feedback: '',
        videoDate: new Date().toString(),
        questionValue: 0,
        userScore: 0,
        options: {},
        correctOptions: [],
        userResponses: [],
        parse: function() {
          self.info.settings = AssessmentLib.helpers.getQuestionOptions($scope.question);
          self.info.questionValue = AssessmentLib.helpers.getQuestionValue($scope.question);
          self.info.userScore = $scope.gradedResponses && $scope.question.id && $scope.gradedResponses[$scope.question.id] && $scope.gradedResponses[$scope.question.id].score;
          self.info.userResponses = $scope.gradedResponses && $scope.question.id && $scope.gradedResponses[$scope.question.id] && $scope.gradedResponses[$scope.question.id].user_answer;
          self.info.feedback = $scope.gradedResponses && $scope.question.id && $scope.gradedResponses[$scope.question.id] && $scope.gradedResponses[$scope.question.id].feedback;
          if (self.info.settings.manual_grade) {
            return;
          }

          if ($scope.question.choice_options && $scope.question.choice_options.length) {
            self.info.options = {};
            self.info.correctOptions = [];
            $scope.question.choice_options.forEach(function(item) {
              self.info.options[item.id] = item && item.copy || '--';
              if (!item.points) {
                return;
              }
              self.info.correctOptions.push(item);
            });
          }
        }
      };

      if (!$scope.question || !$scope.question.choice_options) {
        var optionWatch = $scope.$watch('question', function(newVal, oldVal) {
          self.info.parse();
        });
        return;
      }

      self.info.parse();

    }],
    controllerAs: 'answer'
  };
}]);